import React from 'react'
import { VideoUploader } from 'hlj-components'
// 临时方案，解决公共组件样式不加载
import '@hlj/hlj-components/esm/ImageUploader/style.css'

export default props => {
  const from = props.from || 'MerchantNormalMaterial'
  return (
    <VideoUploader
      uploadOptions={{
        upload_url: 'https://up.qiniup.com', // 上传路径
        image_uptoken_url: '/p/wedding/home/APIUtils/image_upload_token', // 获取图片token的url
        video_uptoken_url:
          '/p/wedding/home/APIUtils/video_upload_token?from=' + from, // 获取上传视频token的url
        domain_url: 'https://qnm.hunliji.com/' // 图片显示前缀路径
      }}
      hide_outside_cover={true} // 是否显示外部封面，默认为true
      max="100mb" //上传视频的大小限制，默认500mb
      {...props}
    />
  )
}
